// export const baseUrl = "http://localhost:8000/";
export const baseUrl = process.env.REACT_APP_API_URL;